module.exports = __webpack_public_path__ + "static/media/upptackt.cffc9827.mp3";